/**
 * Shows/hides membership card based on selected Package option (comma-separated keywords).
 */
class ProductMembershipCard {
  static init(root = document) {
    const scope = root instanceof Element ? root : document;
    scope.querySelectorAll('[data-membership-card]').forEach((card) => {
      if (card.dataset.membershipBound === 'true') return;
      card.dataset.membershipBound = 'true';
      new ProductMembershipCard(card);
    });
  }

  constructor(card) {
    this.card = card;
    this.keywords = (card.dataset.showForPackages || '')
      .split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);

    this.productInfo = card.closest('product-info');
    this.update = this.update.bind(this);

    this.update();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribers = [
        subscribe(PUB_SUB_EVENTS.variantChange, this.update),
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.update),
      ];
    } else {
      this.productInfo?.addEventListener('change', this.update);
    }
  }

  getSelectedPackageValue() {
    const fieldset = this.productInfo?.querySelector('.product-form__input--package');
    const input = fieldset?.querySelector('input:checked');
    return input?.value?.trim().toLowerCase() || '';
  }

  update() {
    if (!this.keywords.length) {
      this.card.hidden = false;
      return;
    }

    const packageValue = this.getSelectedPackageValue();
    const show = this.keywords.some((keyword) => packageValue.includes(keyword));
    this.card.hidden = !show;
  }
}

document.addEventListener('DOMContentLoaded', () => ProductMembershipCard.init());
document.addEventListener('shopify:section:load', (event) => ProductMembershipCard.init(event.target));
